// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"0eebab7c","362":"ee04a8a4","453":"03346f77","573":"df32fe50","724":"14de3469","861":"a5ca547f"}[chunkId] + ".chunk.js";
};